<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">{{ !loading ? (isEditMode ? "Edit" : "Create") : "" }} Metadata Map</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/ptpmetadatamap">Back to PTP Metadata Maps</a>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-body">
                <form nz-form [formGroup]="form" class="form-horizontal">
                    <div class="form-group">
                        <label for="columnName" class="col-md-2 control-label">
                            PO Field<span style="color: red"> *</span>
                        </label>
                        <div class="col-md-6">
                            <nz-select
                                id="columnName"
                                style="width: 100%"
                                nzShowSearch
                                nzAllowClear
                                nzPlaceHolder="Select a PO field"
                                formControlName="columnName">
                                @for (field of poFieldNames; track field) {
                                    <nz-option [nzValue]="field" [nzLabel]="field"></nz-option>
                                }
                            </nz-select>
                            @if (form.get("columnName")?.touched && form.get("columnName")?.invalid) {
                                <span class="text-danger"> Select a PO field </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="metaDataDefinitionID" class="col-md-2 control-label">
                            Metadata Field<span style="color: red"> *</span>
                        </label>
                        <div class="col-md-6">
                            <nz-select
                                id="metaDataDefinitionID"
                                style="width: 100%"
                                nzShowSearch
                                nzAllowClear
                                nzPlaceHolder="Select a metadata field"
                                formControlName="metaDataDefinitionID">
                                @for (def of metaDataDefinitions; track def.MetaDataDefinitionID) {
                                    <nz-option
                                        [nzValue]="def.MetaDataDefinitionID"
                                        [nzLabel]="def.MetaDataDefinitionName"></nz-option>
                                }
                            </nz-select>
                            @if (
                                form.get("metaDataDefinitionID")?.touched && form.get("metaDataDefinitionID")?.invalid
                            ) {
                                <span class="text-danger"> Select a metadata field </span>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <button nz-button nzType="primary" (click)="save()">Save Changes</button>
    </div>
</div>
